import { useState } from "react";

import { useFormContext } from "react-hook-form";

import Badge from "@/tpo/Badge";
import Group from "@/tpo/Group";
import InputWrapper from "@/tpo/InputWrapper";
import Menu, { Button } from "@/tpo/Menu";

export default function SpecialismsField({ specialisms }) {
  const { setValue, watch, getFieldState, clearErrors } = useFormContext();
  const specialismsValue = watch("specialisms");
  const [showFilterMenu, setShowFilterMenu] = useState(false);

  const { error } = getFieldState("specialisms");

  return (
    <>
      <InputWrapper
        error={error?.message}
        input={
          <Menu opened={showFilterMenu} onChange={setShowFilterMenu} trigger="hover">
            <Menu.Target>
              <Button
                open={showFilterMenu}
                color="dark"
                data-component-name="specialisms"
                sx={{
                  color: "white"
                }}
              >
                Select Option
              </Button>
            </Menu.Target>
            <Menu.Dropdown
              mt={2}
              py={2}
              zIndex={2}
              minWidth={200}
              height={400}
              maxHeight={400}
              overflowY="auto"
            >
              {specialisms.map(sortOption => (
                <Menu.Item
                  onClick={() => {
                    if (specialismsValue.includes(sortOption.id)) {
                      setValue(
                        "specialisms",
                        specialismsValue.filter(id => sortOption.id !== id)
                      );
                    } else {
                      setValue("specialisms", [...specialismsValue, sortOption.id]);
                    }
                    clearErrors(["specialisms"]);
                  }}
                  selected={specialismsValue.includes(sortOption.id)}
                  key={sortOption.id}
                  fontSize={14}
                  lineHeight={1.7}
                  py={16}
                  data-testid={`specialismsOption:${sortOption.name}`}
                >
                  {sortOption.name}
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
        }
      />
      <Group gap={8} flexWrap="wrap">
        {specialismsValue.map(id => (
          <Badge
            bg="green"
            color="white"
            size={["sm", "sm", "md"]}
            data-testid="specialismsValue"
            key={id}
          >
            {specialisms.find(({ id: _id }) => id === _id)?.name}
          </Badge>
        ))}
      </Group>
    </>
  );
}
